import { Typography } from '@mui/material';
import { ReactElement } from 'react';
import { Text } from './Text';

export function Imprint(): ReactElement {
  return (
    <Text>
      <Typography variant="h2">Impressum</Typography>
      <Typography>
        Die Energy2market GmbH ist eine Gesellschaft mit beschränkter Haftung nach deutschem Recht.
      </Typography>
      <section>
        <Typography variant="h3">Herausgeber</Typography>
        <Typography>
          Energy2market GmbH
          <br />
          Weißenfelser Str. 84
          <br />
          04229 Leipzig
        </Typography>
        <Typography>
          Telefon: +49 341 230 28 0
          <br />
          E-Mail: servicecenter[at]e2m.energy
        </Typography>
      </section>
      <section>
        <Typography variant="h3">Geschäftsführer</Typography>
        <Typography>Hannes Behacker</Typography>
      </section>
      <section>
        <Typography variant="h3">Eingetragen</Typography>
        <Typography>
          Sitz der Gesellschaft: Leipzig
          <br />
          Amtsgericht Leipzig
          <br />
          Handelsregister Nr.: HRB 25060
          <br />
          USt-IdNr.: DE 266047759
          <br />
        </Typography>
        <Typography>Verantwortlich i. S. v. § 2 Absatz 1 Telemediengesetz (TMG): Energy2market GmbH</Typography>
      </section>
      <section>
        <Typography variant="h3">Steuerliche Details Energy2market GmbH</Typography>
        <Typography>USt-IdNr.: DE 266047759</Typography>
      </section>
    </Text>
  );
}
